export const keyboardShortcutsArticles = [
    {
        id: 'features.keyboard-shortcuts',
        title: 'Keyboard Shortcuts',
        category: 'Features',
        order: 1,
        summary: 'Complete reference of keyboard shortcuts for faster navigation',
        content: `
Costed.app supports keyboard shortcuts to help you work more efficiently. Press **?** (Shift + /) at any time to view available shortcuts.

**Global Shortcuts:**

| Shortcut | Action |
|----------|--------|
| **?** | Show keyboard shortcuts help |
| **F1** | Open help panel |
| **Ctrl+K** | Open command bar |
| **Esc** | Close modal/panel |

**Navigation:**

| Shortcut | Action |
|----------|--------|
| **G then D** | Go to Dashboard |
| **G then J** | Go to Jobs |
| **G then B** | Go to BOQ |
| **G then C** | Go to Catalogue |
| **G then O** | Go to Orders |
    `,
        expandableSections: [
            {
                title: 'BOQ Page Shortcuts',
                content: `
| Shortcut | Action |
|----------|--------|
| **Ctrl+K** | Toggle catalogue search |
| **Ctrl+S** | Save changes |
| **Del** | Delete selected rows |
| **Ctrl+Z** | Undo |
| **Ctrl+Y** | Redo |
| **F5** | Refresh data |

**Grid Navigation:**
| Shortcut | Action |
|----------|--------|
| **Tab** | Move to next cell |
| **Shift+Tab** | Move to previous cell |
| **Enter** | Edit cell / Confirm |
| **Esc** | Cancel edit |
| **Ctrl+A** | Select all rows |
        `,
            },
            {
                title: 'Grid Editing Shortcuts',
                content: `
| Shortcut | Action |
|----------|--------|
| **F2** | Start editing cell |
| **Backspace** | Clear cell and edit |
| **Ctrl+C** | Copy selected cells |
| **Ctrl+V** | Paste |
| **Ctrl+X** | Cut |
| **Space** | Toggle checkbox (in checkbox columns) |
        `,
            },
            {
                title: 'Command Bar',
                content: `
Press **Ctrl+K** to open the command bar. Type to search for:

- Pages (e.g., "jobs", "boq", "orders")
- Recent jobs
- Actions (e.g., "create order", "add item")

Use arrow keys to navigate results and Enter to select.
        `,
            },
        ],
        keywords: ['keyboard', 'shortcuts', 'hotkeys', 'keys', 'accelerators', 'quick'],
        relatedArticles: ['getting-started.navigation', 'boq.overview'],
    },
];
